/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import RenderNode from "App/render/webgl/nodes/render_node";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import RenderObject from "App/geometry/objects/object";
import {ERenderableFilters} from "App/render/webgl/render_state";
import Factory from "App/render/webgl/nodes/factory";
import Pass from "App/render/webgl/passes/pass";
import RenderablesFactory from "App/render/webgl/renderables/factory";
import Material from "App/render/webgl/renderables/material";
import {MaterialNodeTypeName} from "App/render/webgl/nodes/type_names";
import IScene from "js_interface/src/scene_interface";

export default
class MaterialNode extends RenderNode {

    public static TypeName: string = MaterialNodeTypeName;

    private readonly renderable: Material;

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aParentNode: RenderNode, aShape: RenderObject) {
        super(aSceneAPI, aRenderGraph, aParentNode, aShape);

        this._typeName = MaterialNode.TypeName;

        this.renderable = RenderablesFactory.create(Material, aSceneAPI, aRenderGraph, this) as Material;
        this.renderable.setProperties(this.appearance.surfaceColor);
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aParentNode: RenderNode, aShape: RenderObject) {
        return new MaterialNode(aSceneAPI, aRenderGraph, aParentNode, aShape);
    }

    public release() {
        super.release();
        if (this.renderable) {
            this.renderable.release();
        }
    }

    public compareProperties(aShape: RenderObject): boolean {
        return aShape.appearance.surfaceColor === this.appearance.surfaceColor;
    }

    public countShapesAndUniqueTextures(aStatistics) {
        aStatistics.addMaterialNode();

        super.countShapesAndUniqueTextures(aStatistics);
    }

    public render(aRenderPass: Pass) {
        this._render(aRenderPass);

        return super.render(aRenderPass);
    }

    private _render(aRenderPass: Pass) {
        if (aRenderPass.state.getRenderableFilterIsSet(ERenderableFilters.material)) {
            this.renderable.render(aRenderPass);
        }
    }
}

Factory.register(MaterialNode);
